var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome4.01cca6ac.png","uri@2x": __webpack_public_path__ + "static/media/welcome4.57f90ff6.png","uri@3x": __webpack_public_path__ + "static/media/welcome4.6292d915.png",
    width: 201,
    height: 201
});